import React, { useMemo } from 'react';
import Preview from 'components/commercetools-ui/organisms/checkout/components/steps/previews/wrapper';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import useLocale from 'helpers/hooks/useLocale';
import { useCart } from 'frontastic';
import { DateHelpers } from 'helpers/dateHelpers';

const AmazonPayShippingPreview = () => {
  const { ctLocale: locale } = useLocale();

  const { data, shippingMethods, estimatedShippingPrice } = useCart();

  const shippingMethod = useMemo(() => {
    if (!data?.shippingInfo) {
      return {
        name: 'Est. Delivery Cost',
        price: estimatedShippingPrice,
        description: '',
      };
    }

    let description;
    if (data?.shippingInfo?.name) {
      description = shippingMethods?.data?.find((sm) => sm.name === data?.shippingInfo?.name)?.description;
    }

    return {
      name: data?.shippingInfo?.name ?? '',
      price: data?.shippingInfo.price,
      description: description,
      deliveryDate: data?.custom?.deliveryDate ?? '',
    };
  }, [data, shippingMethods?.data]);

  return (
    <Preview>
      <div className="border border-neutral-400 p-16">
        <div className="flex items-center justify-between border-l-4 border-ag_color-text_green py-18 pl-18">
          <div>
            <p className="text-14 font-medium">{shippingMethod?.name}</p>
            <p className="mt-4 text-14 font-light text-secondary-black">
              {shippingMethod?.deliveryDate
                ? DateHelpers.formatDateVerbose(shippingMethod.deliveryDate)
                : shippingMethod?.description}{' '}
            </p>
          </div>

          <span className="text-14 font-medium">
            {CurrencyHelpers.formatForCurrency(shippingMethod?.price ?? {}, locale)}
          </span>
        </div>
      </div>
    </Preview>
  );
};

export default AmazonPayShippingPreview;
